// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_gr-0";
export var discountCodeInput = "_gr-1";